import styled from 'styled-components';

import { StyledLink } from './StyledLink';

export const SubtleMetaLink = styled(StyledLink)`
  font-size: 11px;
  line-height: 16px;
`;
